/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ErrorSeverity } from './ErrorSeverity';
import {
    ErrorSeverityFromJSON,
    ErrorSeverityFromJSONTyped,
    ErrorSeverityToJSON,
} from './ErrorSeverity';
import type { NotificationAction } from './NotificationAction';
import {
    NotificationActionFromJSON,
    NotificationActionFromJSONTyped,
    NotificationActionToJSON,
} from './NotificationAction';
import type { NotificationState } from './NotificationState';
import {
    NotificationStateFromJSON,
    NotificationStateFromJSONTyped,
    NotificationStateToJSON,
} from './NotificationState';

/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    readonly title: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    readonly message: string;
    /**
     * 
     * @type {NotificationAction}
     * @memberof Notification
     */
    action?: NotificationAction;
    /**
     * 
     * @type {NotificationState}
     * @memberof Notification
     */
    status: NotificationState;
    /**
     * 
     * @type {ErrorSeverity}
     * @memberof Notification
     */
    severity: ErrorSeverity;
    /**
     * 
     * @type {Date}
     * @memberof Notification
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Notification
     */
    readonly expiryAt?: Date;
}

/**
 * Check if a given object implements the Notification interface.
 */
export function instanceOfNotification(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "severity" in value;
    isInstance = isInstance && "createdAt" in value;

    return isInstance;
}

export function NotificationFromJSON(json: any): Notification {
    return NotificationFromJSONTyped(json, false);
}

export function NotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Notification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'message': json['message'],
        'action': !exists(json, 'action') ? undefined : NotificationActionFromJSON(json['action']),
        'status': NotificationStateFromJSON(json['status']),
        'severity': ErrorSeverityFromJSON(json['severity']),
        'createdAt': (new Date(json['createdAt'])),
        'expiryAt': !exists(json, 'expiryAt') ? undefined : (new Date(json['expiryAt'])),
    };
}

export function NotificationToJSON(value?: Notification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action': NotificationActionToJSON(value.action),
        'status': NotificationStateToJSON(value.status),
        'severity': ErrorSeverityToJSON(value.severity),
    };
}

